<template>
	<!-- We use v-on:input as well as v-model because we need to use nextTick to bubble up the event to the parent -->
	<select2 :options="postCategoryOptions" v-model="selectedPostCategoryId" v-on:input="emitSelectedItem()"></select2>
</template>

<script>

	export default {
		props: ['value'],
		data: function () {
			return {
				postCategoryOptions: [],
				selectedPostCategoryId: this.value,
				loading: false
			}
		},
		mounted() {
			console.log('Post Category options component mounted.');
			this.getPostCategories();
		},
		methods: {
			getPostCategories() {
				if (this.loading == false) {
					this.loading = true;
					axios.get('/api/v1/newsfeed/post_categories/all').then((response) => {
						this.postCategoryOptions = [];
						this.postCategoryOptions.push({id:0, text: "-- Please Select --"})
						console.log(response.data);
						for (var post_category of response.data) {
							this.postCategoryOptions.push({
								id: post_category.id,
								text: post_category.category
							});
						}
						this.loading = false;
					}).catch((error) => {
						this.loading = false;
						this.handleHTTPError(error);
					});
				} else {
					this.loading = false;
					this.postCategoryOptions = [];
				}
			},
			emitSelectedItem() {
				console.log('Post Category changed');
				// We use nextTick because we have to wait for the value of the select2 to update
				this.$nextTick(function() {
					this.$emit('input', this.selectedPostCategoryId);
				})
			},
			handleHTTPError(error) {
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range of 2xx
						console.log(error.response.data); // Error message
						console.log(error.response.status);
						console.log(error.response.headers);
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						console.log(error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', error.message);
					}
					console.log(error.config);
			}

		}
	}
</script>